import { Component, Input, OnInit, inject } from '@angular/core';
import { WidgetBaseComponent } from '@shared/widgets/widget-base/widget-base.component';
import { TenantService } from '@core/tenant/tenant.service';

@Component({
  selector: 'ade-classified-card',
  templateUrl: './classified-card.component.html',
  styleUrls: ['./classified-card.component.scss'],
})
export class AdeClassifiedCardComponent
  extends WidgetBaseComponent
  implements OnInit
{
  @Input() item: any;

  private _tenant = inject(TenantService);

  get showPrices(): boolean {
    return this._tenant.showPrices;
  }

  ngOnInit(): void {}
}
